<template>
    <div>
        <div v-if="disabled" class="overlay" :class="{ revoked }">
            <transition @enter="stampCard">
                <v-img
                    class="revoked-image"
                    src="@/assets/check_cards_not_reusable.svg"
                    v-if="revoked"
                >
                </v-img>
            </transition>
        </div>
        <v-img
            class="kk-card"
            :class="{ sending, receiving }"
            :src="
                $vuetify.breakpoint.smAndDown
                    ? require('@/assets/card/enter-pin-xs.png')
                    : require('@/assets/card/enter-pin-md.png')
            "
            cover
        >
            <display-amount
                class="balance-display-wrapper"
                :amount="amount"
                :currency="currency"
                :go-green="combineComplete"
            ></display-amount>
            <info-section
                v-if="infoMessage !== undefined && !combineComplete"
                :receiving="receiving"
                >{{ infoMessage }}</info-section
            >
            <v-btn
                v-if="!sending && !receiving"
                class="card-btn"
                rounded
                :width="buttonWidth"
                height="54"
                @click="$emit('reset-check-balance')"
                >CHECK ANOTHER BALANCE</v-btn
            >
            <v-btn
                v-else-if="receiving && !combineComplete"
                :disabled="disableCombine"
                class="card-btn"
                rounded
                :width="buttonWidth"
                height="54"
                @click="requestCombineBalance"
                >Combine balance</v-btn
            >
            <vue-recaptcha
                v-if="recaptchaLoaded"
                ref="recaptcha"
                :sitekey="recaptchaSiteKey"
                size="invisible"
                @verify="recaptchaV2Verified"
                @expired="resetRecaptcha"
            />
            <v-tooltip
                v-else-if="receiving && combineComplete"
                v-model="showTooltip"
                :open-on-hover="false"
                top
            >
                <template v-slot:activator="{ on }">
                    <div
                        slot="activator"
                        v-on="on"
                        @click="copyPinToClipboard"
                        class="complete-info"
                    >
                        <span>Use this PIN to make purchases</span>
                        <v-text-field
                            class="card-input"
                            autocomplete="false"
                            :value="combinedPin"
                            label="ENTER PIN"
                            disabled
                            solo
                        ></v-text-field>
                    </div>
                </template>
                <span>PIN copied to clipboard</span>
            </v-tooltip>

            <div
                class="justify-center align-center bottom-action-wrapper"
                :class="{
                    'change-cards': sending,
                    cancel: receiving && !combineComplete,
                    'ready-combine': !sending && !receiving && !disableCombine,
                }"
            >
                <a
                    v-if="sending"
                    @click="$emit('transition-enter-pin')"
                    class="bottom-action"
                >
                    Want to change cards?
                </a>
                <a
                    v-else-if="receiving && !combineComplete"
                    @click="$emit('transition-enter-pin')"
                    class="bottom-action"
                >
                    CANCEL
                </a>
                <a
                    v-else-if="receiving && combineComplete"
                    @click="$emit('reset-all')"
                    class="bottom-action"
                >
                    Ready to combine more cards?
                </a>
                <a
                    v-else-if="!disableCombine"
                    @click="emitBalance"
                    class="bottom-action"
                    >Ready to combine cards?</a
                >
            </div>
        </v-img>
    </div>
</template>

<script>
import displayAmount from '@/components/card/state/balance/display-amount';
import infoSection from '@/components/card/state/balance/info-section';
import VueRecaptcha from 'vue-recaptcha';
import recaptchaKeys from '@/config/recaptcha-key';

export default {
    name: 'card-balance',
    components: { displayAmount, infoSection, VueRecaptcha },
    props: {
        amount: {
            type: Number,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        infoMessage: {
            type: String,
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        revoked: {
            type: Boolean,
            default: false,
        },
        sending: {
            type: Boolean,
            default: false,
        },
        receiving: {
            type: Boolean,
            default: false,
        },
        disableCombine: {
            type: Boolean,
            default: false,
        },
        combineComplete: {
            type: Boolean,
            default: false,
        },
        combinedPin: {
            type: String,
            default: undefined,
        },
        recaptchaLoaded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showTooltip: false,
        };
    },
    computed: {
        buttonWidth() {
            if (this.$vuetify.breakpoint.xsOnly) {
                return 260;
            } else if (this.$vuetify.breakpoint.smOnly) {
                return 446;
            }
            return 308;
        },
        recaptchaSiteKey() {
            return recaptchaKeys.v2;
        },
    },
    methods: {
        requestCombineBalance() {
            this.$emit('combine-balance');
        },
        emitBalance() {
            this.$emit('goto-combine');
        },
        recaptchaV2Verified(token) {
            this.$emit('recaptcha-V2-verified', token);
        },
        resetRecaptcha() {
            if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset();
                this.$emit('reset-recaptcha');
            }
        },
        stampCard(el, done) {
            window.Velocity(
                el,
                { width: '1000%', 'max-width': '1000%' },
                {
                    duration: 0,
                }
            );
            window.Velocity(
                el,
                { width: '100%', 'max-width': '100%' },
                {
                    duration: 1000,
                    complete: done,
                }
            );
        },
        copyPinToClipboard() {
            const dummy = document.createElement('input');
            dummy.value = this.combinedPin;
            dummy.height = 0;
            dummy.width = 0;
            document.body.appendChild(dummy);
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            this.showTooltip = true;
            window.setTimeout(() => {
                this.showTooltip = false;
            }, 2000);
        },
    },
};
</script>

<style lang="scss" scoped>
.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(20, 20, 20, 0.7);
    border-radius: 16px;
    z-index: 1;
    &.revoked {
        overflow: hidden;
        background-color: rgba(30, 30, 30, 0.97);
    }
    .revoked-image {
        top: 15%;
        @include break('sm') {
            top: -10%;
        }
        @include break('md') {
            top: 24%;
        }
    }
}

@media (max-width: 1081px) {
    .overlay {
        border-radius: 9px;
    }
}
.kk-card {
    height: 300px;
    width: 300px;
    @include break('sm') {
        width: 500px;
    }
    @include break('md') {
        width: 380px;
        height: 562px;
    }
    .balance-display-wrapper {
        margin-top: 78px;
        margin-bottom: 50px;
        @include break('md') {
            margin-top: 190px;
            margin-bottom: 73px;
        }

        @include break('xs') {
            margin-bottom: 0;
        }
    }

    .balance-display-wrapper {
        margin-bottom: 9px;
    }

    .kk-card-title {
        color: white;
        font-size: 36px;
        text-align: center;
        padding-top: 96px;
        margin: 0;
        line-height: 0.8;
    }
    .card-btn {
        position: static;
        color: #ffffff;
        background-color: #2960e8 !important;
        // bottom: 50px;
        // left: 50%;
        // transform: translate(-50%, 0%);
    }
    &.receiving {
        .card-btn {
            margin-top: 10px;
            @include break('md') {
                margin-top: 20px;
            }
        }
    }
    .bottom-action-wrapper {
        .bottom-action {
            color: #2960e8;
            text-decoration: underline;
            font-size: 13px;
        }
        &.cancel {
            padding-top: 2px;
            @include break('md') {
                padding-top: 2px;
            }
        }
        &.change-cards {
            padding-top: 42px;
            @include break('md') {
                padding-top: 50px;
            }
        }
        &.ready-combine {
            padding-top: 6px;
            @include break('md') {
                padding-top: 9px;
            }
        }
    }
}
.complete-info {
    color: white;
    font-size: 14px;
    margin-top: 36px;
    .card-input {
        margin: 10px 20px 2px 20px;
        @include break('md') {
            margin: 10px 36px;
        }

        border-radius: 9px;
        border: solid 1px rgba(0, 0, 0, 0.3);
    }
}
</style>

<style lang="scss">
.complete-info {
    .card-input {
        .v-text-field__slot {
            input {
                text-align: center;
            }
        }
    }
}
</style>
